// Caroline presentation labels supplement the shared translation catalog.
module.exports = {
    'en-US': {
        CAROLINE_STREAM_SEARCHING: 'Looking for sources…',
        CAROLINE_STREAM_VERIFYING: 'Checking available sources…',
        CAROLINE_STREAMS_UNAVAILABLE: 'Some sources could not be reached. Try again later.',
        CAROLINE_STREAMS_SLOW: 'Sources are taking longer than expected. Options will appear when they respond.',
        CAROLINE_TRAILER_LOADING: 'Loading trailer…',
        CAROLINE_TRAILER_UNAVAILABLE: 'This trailer could not be loaded. Try again later.',
        CAROLINE_CLEAR_SEARCH: 'Clear search',
        CAROLINE_BACK: 'Back',
        CAROLINE_ACCOUNT_MENU: 'Account menu',
        CAROLINE_RETRY: 'Try again',
        CAROLINE_CHANGE_SOURCE: 'Change source',
        CAROLINE_TRAILER_EXTERNAL: 'Watch trailer on YouTube',
        CAROLINE_PLAYER_CONTROLS: 'Playback controls',
        CAROLINE_PLAYER_STATISTICS: 'Playback statistics',
        CAROLINE_PLAYER_CAST: 'Cast',
        CAROLINE_PLAYER_EPISODES: 'Episodes',
        CAROLINE_PLAYER_OPTIONS: 'Player options',
        CAROLINE_PLAYER_POSITION: 'Playback position',
        CAROLINE_PLAYER_VOLUME: 'Volume'
    },
    'pt-PT': {
        CAROLINE_STREAM_SEARCHING: 'A procurar opções…',
        CAROLINE_STREAM_VERIFYING: 'A verificar opções disponíveis…',
        CAROLINE_STREAMS_UNAVAILABLE: 'Não foi possível consultar algumas fontes. Volta a tentar mais tarde.',
        CAROLINE_STREAMS_SLOW: 'As fontes estão a demorar mais do que o esperado. As opções aparecerão quando responderem.',
        CAROLINE_TRAILER_LOADING: 'A carregar trailer…',
        CAROLINE_TRAILER_UNAVAILABLE: 'Não foi possível carregar este trailer. Tenta novamente mais tarde.',
        CAROLINE_CLEAR_SEARCH: 'Limpar pesquisa',
        CAROLINE_BACK: 'Voltar',
        CAROLINE_ACCOUNT_MENU: 'Menu da conta',
        CAROLINE_RETRY: 'Tentar novamente',
        CAROLINE_CHANGE_SOURCE: 'Trocar fonte',
        CAROLINE_TRAILER_EXTERNAL: 'Ver trailer no YouTube',
        CAROLINE_PLAYER_CONTROLS: 'Controlos de reprodução',
        CAROLINE_PLAYER_STATISTICS: 'Estatísticas de reprodução',
        CAROLINE_PLAYER_CAST: 'Transmitir',
        CAROLINE_PLAYER_EPISODES: 'Episódios',
        CAROLINE_PLAYER_OPTIONS: 'Opções do Player',
        CAROLINE_PLAYER_POSITION: 'Posição de reprodução',
        CAROLINE_PLAYER_VOLUME: 'Volume'
    }
};
